import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  ...paginate
}

const veiculoDenatranRepository = createRepository({
  path: 'veiculos-denatran',
  restApi,
  queryTransform: {
    ...paginate
  }
})

veiculoDenatranRepository.manualFetch = ({
  solicitacaoId,
  placa,
  codRenavam,
  cpfcnpj
}) =>
  restApi.post(`/veiculos-denatran/manual-fetch/${solicitacaoId}`, {
    placa,
    codRenavam,
    cpfcnpj
  })

veiculoDenatranRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/veiculos-denatran' + queryString, {}, options)
}

export default veiculoDenatranRepository
